export const GIT_BRANCH = "master"
export const GIT_HASH = "7fb2f5ecd95bdf0e3f1469d5bfe61fde2028b663"
export const BUILD_NUM = "master.2023.05.10.01"
export const THEME_COLOR = "#808080"
export const PRIMARY_COLOR = "#ffffff"
export const TERTIARY_COLOR = "#414142"
export const ASSETS_BASE_URL = "https://web-order.flipdish.co/client/productionwlbuild/latest/"
export const DEFAULT_API_URL = "https://api.flipdish.co/"
export const DEFAULT_PATH_EMBEDDED = "https://web-order.flipdish.co/production/embedded/latest/index.html"
